import { create } from 'zustand';
import { notificationsApi, NotificationDto } from '../api/notifications';

interface NotificationState {
  notifications: NotificationDto[];
  unreadCount: number;
  loading: boolean;

  fetchNotifications: () => Promise<void>;
  addNotification: (n: NotificationDto) => void;
  markAllRead: () => Promise<void>;
  markOneRead: (id: string) => Promise<void>;
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],
  unreadCount: 0,
  loading: false,

  fetchNotifications: async () => {
    set({ loading: true });
    try {
      const [listRes, countRes] = await Promise.all([
        notificationsApi.getAdminNotifications(),
        notificationsApi.getAdminUnreadCount(),
      ]);
      set({
        notifications: listRes.data,
        unreadCount: countRes.data.count,
        loading: false,
      });
    } catch {
      set({ loading: false });
    }
  },

  // Called by SignalR when a new notification arrives in real-time
  addNotification: (n: NotificationDto) => {
    set((state) => ({
      notifications: [n, ...state.notifications],
      unreadCount: state.unreadCount + (n.isRead ? 0 : 1),
    }));
  },

  markAllRead: async () => {
    await notificationsApi.markAllAdminRead();
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
      unreadCount: 0,
    }));
  },

  markOneRead: async (id: string) => {
    await notificationsApi.markAsRead(id);
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, isRead: true } : n
      ),
      unreadCount: Math.max(0, state.unreadCount - 1),
    }));
  },
}));
